import ApiOperation from '../ApiOperation';

import * as apiConstants from '../apiConstants';


class ApiResponse extends ApiOperation {

    /**
     * @type {number}
     * @private
     */
    statusCode;


    /**
     * @param statusCode {number} Http status code of the response
     */
    constructor(statusCode) {

        super();

        this.statusCode = statusCode;
    }


    /**
     * @returns {number} Http status code
     */
    getStatusCode() {

        return this.statusCode;
    }


    /**
     * @returns {boolean} True if status-code is any of 2**
     */
    isSuccessful() {

        const statusCode = this.getStatusCode();

        return statusCode >= apiConstants.HTTP_STATUS_OK
            && statusCode < apiConstants.HTTP_STATUS_MULTIPLE_CHOICES;
    }


    /**
     * @returns {boolean} True if status-code is NOT any of 2**
     */
    isErroneous() {

        return !this.isSuccessful();
    }


    /**
     * @return {boolean} True if status code is 400 BAD REQUEST
     */
    isBadRequest() {

        return this.getStatusCode() === apiConstants.HTTP_STATUS_BAD_REQUEST;
    }


    /**
     * @return {boolean} True if status code is 409 CONFLICT
     */
    isConflict() {

        return this.getStatusCode() === apiConstants.HTTP_STATUS_CONFLICT;
    }


    /**
     * @return {boolean} True if status code is 404 NOT_FOUND
     */
    isNotFound() {

        return this.getStatusCode() === apiConstants.HTTP_STATUS_NOT_FOUND;
    }


    /**
     * @return {object} Loggable output
     */
    toLog() {

        return {
            statusCode: this.getStatusCode(),
            ...super.toLog()
        };
    }


    /**
     * Returns violation errors in the <field>: {type: <type>} formatted object
     *
     * @see ValidatingForm
     *
     * @return {{}} Violation errors keyed by field and message value mapping
     */
    getValidationFieldErrors() {

        const body = this.getBody() || {};
        const violations = body.violations || [];

        const violationErrors = {};
        violations.forEach(({field, message}) => {
            violationErrors[field] = {
                type: message
            };
        });

        return violationErrors;
    }
}


export default ApiResponse;
